module.exports = __webpack_public_path__ + "media/images/testimonial3-48c7a0e59c1d0a995a84881e58302d5d.jpg";